import { Circle } from 'rc-progress';
import { retry } from '@/bussiness/AudioImportHandler';
import { ImportRecord, ImportStatus } from '@/types/fileImport';
import IC_AUDIO_FILE from '@/assets/import/ic_file_audio.svg?react';
import IC_RETRY from '@/assets/import/ic_retry.svg?react';
import IC_CLOSE from '@/assets/common/ic_close.svg?react';
import IC_LOADING from '@/assets/import/ic_loading.svg?react';
import IC_ERROR from '@/assets/import/ic_error.svg?react';
import { getStatusText, isErrorStatus } from '../util';

interface UploadStationItemProps {
  record: ImportRecord;
  onDelete: (name: string, id: string) => void;
}

export default function UploadStationItem({ record, onDelete }: UploadStationItemProps) {
  if (record.status === ImportStatus.TRANS_SUCCESS) {
    console.log(`记录${record.fileName}转写完毕，不显示`);
    return null;
  }

  const text = getStatusText(record.status, record.uploadProcess, record.remainTime);
  const isError = isErrorStatus(record.status);

  const handleRetry = () => {
    retry(record.id);
  };

  const handleDelete = () => {
    onDelete(record.fileName, record.id);
  };

  return (
    <div className='flex items-center h-17 w-112 px-6'>
      <IC_AUDIO_FILE className='w-8 h-8 mr-4' />
      <div className='flex-1 flex flex-col items-start overflow-hidden'>
        <span className='w-full text-size-4 text-#0D062D truncate mr-3 text-align-start'>
          {record.fileName}
        </span>
        <div className='flex mt-1 items-center'>
          {record.status === ImportStatus.UPLOADING && (
            <Circle
              className='w-3.5 h-3.5 mr-1'
              percent={record.uploadProcess}
              strokeWidth={16}
              strokeColor='#4981F2'
              trailWidth={16}
              trailColor='#ECEEF3'
            />
          )}
          {record.status === ImportStatus.WAITING && (
            <IC_LOADING className='rotation w-4 h-4 mr-1' />
          )}
          {isError && <IC_ERROR className='w-4 h-4 mr-1' />}
          {record.status <= ImportStatus.TRANSING ? (
            <span className='text-#A1A7B2 text-size-3'>{text}</span>
          ) : (
            <span className='text-#FF584C text-size-3'>{text}</span>
          )}
        </div>
      </div>
      {isError && (
        <IC_RETRY className='w-4.5 h-4.5 mr-4 cursor-pointer' onClick={handleRetry} />
      )}
      <IC_CLOSE className='w-4.5 h-4.5 cursor-pointer' onClick={handleDelete} />
    </div>
  );
}
